import React, {Component, PropTypes} from 'react';
import Appbar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import List, {ListItem} from 'material-ui/List';
import Card from 'material-ui/Card';
import Credit from 'material-ui/svg-icons/action/credit-card';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import Link from 'react-router/lib/Link';
import AlertsStore from '../reflux/stores/AlertsStore';
import AlertActions from '../reflux/AlertActions';
import env from '../env';
import User from 'material-ui/svg-icons/action/account-circle';
import Count from 'material-ui/svg-icons/editor/format-list-numbered';
import Lista from 'material-ui/svg-icons/action/list';
import Page from 'material-ui/svg-icons/action/description';
import Down from 'material-ui/svg-icons/file/file-download';
import Power from 'material-ui/svg-icons/action/power-settings-new';
import Divider from 'material-ui/Divider';

class AppBar extends Component {
    constructor(props) {
        super(props);
        let dims = this._getWindowDimensions();
        let open = false;
        if (dims.x > 1040) {
            open = true;
            AlertActions.resize(dims);
        }
        this.state = {
            title: '',
            leftIcons: null,
            rightIcons: null,
            open: open,
            dims: dims
        };

        this.handleToggle = this.handleToggle.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleAlerts = this.handleAlerts.bind(this);
        this.handleLogout = this.handleLogout.bind(this);

        this.updateDims = this.updateDims.bind(this);
        this.handleAlerts = this.handleAlerts.bind(this);
    }

    componentDidMount() {
        this.unsubscribe = AlertsStore.listen(this.handleAlerts);
         window.addEventListener('resize', this.updateDims);
    }

    componentWillUnmount() {
        this.unsubscribe();
        window.removeEventListener('resize', this.updateDims);
    }

    handleAlerts(e, title, leftIcons, rightIcons) {
        if (e === 'configureAppBar') {
            this.setState({title: title, leftIcons: leftIcons, rightIcons: rightIcons});
        }
    }


    /**
     * Open Left Drawer if menu icon is touched
     *
     */
    handleToggle() {
        this.setState({open: !this.state.open});
    }

    /**
     * Close Left Drawer when this functions is called
     *
     */
    handleClose() {
        let close = true;
        if (this.state.dims.x < 1040) close = false;
        this.setState({open: close});
    }

    /**
     * Sets the title of the AppBar
     *
     * @param {Array.<React>} icons React Elements or single string for the title
     */
    handleSetAppBarTitle(icons) {
        this.setState({AppBarTitle: icons});
    }

    /**
     * Sets the left icons and its actions in the form of callbacks
     *
     * @param icons Array of React Elements
     */
    handleSetLeftIcons(icons) {
        this.setState({leftIcons: icons});
    }

    /**
     * Sets the right icons and its actions in the form of callbacks
     *
     * @param icons Array of React Elements
     */
    handleSetRightIcons(icons) {
        this.setState({rightIcons: icons});
    }

    handleLogout() {
        localStorage.removeItem('access_token');
        this.props.router.push('login');
    }

    _getWindowDimensions() {
        let w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight|| e.clientHeight|| g.clientHeight;

        return {x, y};
    }

    updateDims() {
        const dims = this._getWindowDimensions();
        let open = false;
        if (dims.x > 1040) open = true;
        else open = false;
        AlertActions.resize(dims);
        this.setState({dims, open: open});
    }

    render() {
        const linkStyle = {
            textDecoration: 'none'
        };

        const rightIcons = <div>{this.state.rightIcons}</div>;
        const leftIcons = <div>{this.state.leftIcons}</div>;
        const docked = this.state.dims.x > 1040;

        return (
            <div>
                <Appbar
                    titleStyle={{marginLeft:this.state.dims.x > 1040 ? 270 : 0}}
                    title={this.state.title}
                    iconElementLeft={this.state.leftIcons ? this.state.leftIcons : null}
                    onLeftIconButtonTouchTap={this.handleToggle}
                    iconElementRight={this.state.rightIcons ? this.state.rightIcons : null}
                    style={{position:'fixed', top:0}}
                    />

                <Drawer
                    docked={docked}
                    width={270}
                    open={this.state.open}
                    onRequestChange={(open) => this.setState({open})}
                    >
                    <Appbar title={<img src="/public/images/logo-retenlo.png" style={{width:150, verticalAlign:'middle', paddingBottom:4}} />} iconElementLeft={<span/>} />
                    <Link style={linkStyle} to="/">
                        <MenuItem onTouchTap={this.handleClose}>Inicio</MenuItem>
                    </Link>

                    <ListItem
                    initiallyOpen={false}
                    primaryTogglesNestedList={true}
                    nestedItems={[
                        <MenuItem
                            key={1} 
                            rightIcon={<Lista />} 
                            nestedLevel={2} 
                            onTouchTap={() => {  
                                this.handleClose(); 
                                this.props.router.push('/retiva'); }}>
                            Ver Todas
                        </MenuItem>,

                        <MenuItem
                            key={2} 
                            rightIcon={<Page/>} 
                            nestedLevel={2} 
                            onTouchTap={() => {  
                                this.handleClose(); 
                                this.props.router.push('/retiva/create'); }}>
                            Generar Nueva
                        </MenuItem>,
               
                        <MenuItem
                            key={3} 
                            rightIcon={<Down />} 
                            nestedLevel={2} 
                            onTouchTap={() => {  
                                this.handleClose(); 
                                this.props.router.push('/retiva/report'); }}>
                        Generar TXT
                        </MenuItem>
  
                    ]}>
                        Retenciones de I.V.A.
                    </ListItem>

                    <ListItem
                    initiallyOpen={false}
                    primaryTogglesNestedList={true}
                    nestedItems={[
                        <MenuItem
                            key={1} 
                            rightIcon={<Lista />} 
                            nestedLevel={2} 
                            onTouchTap={() => {  
                                this.handleClose(); 
                                this.props.router.push('/retislr'); }}>
                            Ver Todas
                        </MenuItem>,

                        <MenuItem
                            key={2} 
                            rightIcon={<Page/>} 
                            nestedLevel={2} 
                            onTouchTap={() => {  
                                this.handleClose(); 
                                this.props.router.push('/retislr/create'); }}>
                            Generar Nueva
                        </MenuItem>
  
                    ]}>
                        Retenciones de I.S.L.R.
                    </ListItem>
                    


                    <MenuItem
                        rightIcon={<ArrowDropRight />}
                        menuItems={
                            <div>

                                <MenuItem 
                                    onTouchTap={() => {  
                                    this.handleClose(); 
                                    this.props.router.push('/proveedores/'); }}>
                                    Ver Todos
                                </MenuItem>
                            
                                <MenuItem 
                                    onTouchTap={() => {  
                                    this.handleClose(); 
                                    this.props.router.push('/proveedores/create'); }}>
                                    Nuevo
                                </MenuItem>
                            
                            </div>
                        }>
                        Proveedores
                    </MenuItem>




                    
                    <MenuItem 
                        rightIcon={<Count/>} 
                        onTouchTap={() => {  
                            this.handleClose(); 
                            this.props.router.push('/correlativos'); }}>
                        Numeración
                    </MenuItem>
                    
                   
                    
                        <ListItem 
                            open={true}
                            initiallyOpen={false}
                            primaryTogglesNestedList={true}
                            nestedItems={[     
                                <MenuItem
                                    key={1}
                                    nestedLevel={2}
                                    rightIcon={<User />}
                                    onTouchTap={() => {  
                                        this.handleClose(); 
                                        this.props.router.push('/user'); }}>
                                    Mis Datos
                                </MenuItem>,
                            
                                <MenuItem
                                    key={2}
                                    nestedLevel={2}
                                    rightIcon={<Credit />}
                                    onTouchTap={() => {  
                                        this.handleClose(); 
                                        this.props.router.push('/user/suscripcion'); }}>
                                    Suscripción
                                </MenuItem>
                            ]}>
                        Configuración
                        </ListItem>
                    

                    <MenuItem
                        rightIcon={<Power/>} 
                        style={{color: this.context.muiTheme.palette.accent1Color}} onTouchTap={this.handleLogout}>
                        Cerrar Sesión
                    </MenuItem>
                </Drawer>
            </div>
        );
    }
}

AppBar.contextTypes = {
  muiTheme: PropTypes.object.isRequired,
};


export default AppBar;



/** WEBPACK FOOTER **
 ** ./app-react/components/AppBar.jsx
 **/